import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/wordpress-simple': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8C119.3 8 8 119.2 8 256 8 392.7 119.3 504 256 504S504 392.7 504 256C504 119.2 392.7 8 256 8zM33 256C33 223.7 39.9 193 52.3 165.3L158.7 456.7C84.3 420.5 33 344.2 33 256zM256 479C234.1 479 213 475.8 193 469.9L259.9 275.5 328.4 463.3C328.9 464.4 329.4 465.4 330 466.4 306.9 474.5 282 479 256 479zM286.7 151.5C300.1 150.8 312.2 149.4 312.2 149.4 324.2 148 322.8 130.3 310.8 131 310.8 131 274.7 133.8 251.4 133.8 229.5 133.8 192.7 131 192.7 131 180.7 130.3 179.3 148.7 191.3 149.4 191.3 149.4 202.7 150.8 214.7 151.5L249.4 246.7 200.6 393 119.4 151.5C132.8 150.8 144.9 149.4 144.9 149.4 156.9 148 155.5 130.3 143.5 131 143.5 131 107.4 133.8 84.1 133.8 79.9 133.8 75 133.7 69.7 133.5 109.6 73 178.1 33 256 33 314 33 366.9 55.2 406.6 91.5 405.6 91.4 404.7 91.3 403.7 91.3 381.8 91.3 366.3 110.4 366.3 130.9 366.3 149.3 376.9 164.8 388.2 183.2 396.7 198 406.6 217.1 406.6 244.7 406.6 263.8 399.3 285.9 389.6 316.8L367.4 391.1 286.7 151.5zM368.1 448.7L436.2 251.8C448.9 220 453.2 194.6 453.2 171.9 453.2 163.7 452.7 156.1 451.7 149 469.1 180.8 479 217.2 479 256 479 338.3 434.4 410.1 368.1 448.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/wordpress-simple.js
// module id = /hyo
// module chunks = 144